import React, { useEffect, useState } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Mission, MissionPanels } from './components/Mission';
import { CommunityStrength } from './components/CommunityStrength';
import { Leadership } from './components/Leadership';
import { AdvisoryCouncil } from './components/AdvisoryCouncil';
import { MakeDifferenceCTA } from './components/MakeDifferenceCTA';
import { NewsBlog } from './components/NewsBlog';
import { HondurasFacts } from './components/HondurasFacts';
import { MediaScroller } from './components/MediaScroller';
import { ConsularAffairs } from './components/ConsularAffairs';
import { BusinessInvestments } from './components/BusinessInvestments';
import { NonprofitDirectory } from './components/NonprofitDirectory';
import { ExploreHonduras } from './components/ExploreHonduras';
import { HondurasQuiz } from './components/HondurasQuiz';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Events } from './components/Events';
import { ConsularBanner } from './components/ConsularBanner';
import { LandingPage } from './components/LandingPage';
import { SocialMediaVoices } from './components/SocialMediaVoices';
import { AdminDashboard } from './components/AdminDashboard';
import { useLanguage } from './contexts/LanguageContext';
import { FeedbackPopup } from './components/FeedbackPopup';
import { ChatbaseWidget } from './components/ChatbaseWidget';
import { ConsularPage } from './pages/ConsularPage';
import { BusinessMapPage } from './pages/BusinessMapPage';
function AppContent({
  showLanding,
  setShowLanding
}: {
  showLanding: boolean;
  setShowLanding: (v: boolean) => void;
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [pendingScroll, setPendingScroll] = useState<string | null>(null);
  const handleSelectLanguage = (lang: 'EN' | 'ES') => {
    setLanguage(lang);
    setShowLanding(false);
  };
  const handleConsularAccess = (lang: 'EN' | 'ES') => {
    setLanguage(lang);
    setShowLanding(false);
    setPendingScroll('consular-affairs');
  };
  useEffect(() => {
    if (!showLanding && pendingScroll) {
      const timer = setTimeout(() => {
        const el = document.getElementById(pendingScroll);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
        setPendingScroll(null);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showLanding, pendingScroll]);
  if (showLanding) {
    return <LandingPage onSelectLanguage={handleSelectLanguage} onConsularAccess={handleConsularAccess} data-id="element-0" />;
  }
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-1">
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ConsularBanner data-id="element-5" />
        <Mission data-id="element-6" />
        <div className="section-divider-blue-accent" data-id="element-7" />
        <NewsBlog data-id="element-8" />
        <div className="section-divider-blue-accent" data-id="element-9" />
        <MediaScroller data-id="element-10" />
        <div className="section-divider-blue-accent" data-id="element-11" />
        <CommunityStrength data-id="element-12" />
        <div className="section-divider-blue-accent" data-id="element-13" />
        <MissionPanels data-id="element-14" />
        <div className="section-divider-blue-accent" data-id="element-15" />
        <Leadership data-id="element-16" />
        <div className="section-divider-blue-accent" data-id="element-17" />
        <AdvisoryCouncil data-id="element-18" />
        <MakeDifferenceCTA data-id="element-19" />
        <div className="section-divider-blue-accent" data-id="element-20" />
        <BusinessInvestments data-id="element-21" />
        <div className="section-divider-blue-accent" data-id="element-22" />
        <ConsularAffairs data-id="element-23" />
        <div className="section-divider-blue-accent" data-id="element-24" />
        <SocialMediaVoices data-id="element-25" />
        <div className="section-divider-blue-accent" data-id="element-26" />
        <NonprofitDirectory data-id="element-27" />
        <div className="section-divider-blue-accent" data-id="element-28" />
        <HondurasQuiz data-id="element-29" />
        <div className="section-divider-blue-accent" data-id="element-30" />
        <ExploreHonduras data-id="element-31" />
        <div className="section-divider-blue-accent" data-id="element-32" />
        <FAQ data-id="element-33" />
      </main>
      <Footer data-id="element-34" />
      <FeedbackPopup data-id="element-35" />
      <ChatbaseWidget data-id="element-36" />
    </div>;
}
export function App() {
  const [showLanding, setShowLanding] = useState(true);
  const [showAdmin, setShowAdmin] = useState(() => window.location.hash === '#/admin');
  const [showConsular, setShowConsular] = useState(() => window.location.hash === '#/consular');
  const [showBusinessMap, setShowBusinessMap] = useState(() => window.location.hash === '#/business-map');
  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash;
      setShowAdmin(hash === '#/admin');
      setShowConsular(hash === '#/consular');
      setShowBusinessMap(hash === '#/business-map');
      // When navigating back to root from a sub-page, skip the landing page
      if (hash === '' || hash === '#') {
        setShowLanding(false);
      }
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);
  const handleReturnToLanding = () => {
    setShowLanding(true);
  };
  if (showAdmin) {
    return <AdminDashboard onBack={() => {
      window.location.hash = '';
      setShowAdmin(false);
    }} data-id="element-37" />;
  }
  if (showConsular) {
    return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-38">
        <ConsularPage data-id="element-39" />
      </LanguageProvider>;
  }
  if (showBusinessMap) {
    return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-40">
        <BusinessMapPage data-id="element-41" />
      </LanguageProvider>;
  }
  return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-42">
      <AppContent showLanding={showLanding} setShowLanding={setShowLanding} data-id="element-43" />
    </LanguageProvider>;
}